// 🆕 [Phase 56.3] Extrait de CalendrierProduction.jsx — dialog "BT avec dates séparées".
// Quand un BT a des dates non-consécutives (= plusieurs segments), permet de choisir
// quel segment déplacer OU de déplacer le bloc entier.
//
// Payload data : { bon, segments } où segments = [[date1, date2, ...], [date3, ...]]
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

function DialogSegmentChoice({ data, onClose, onSegmentSelect, onBlockSelect }) {
  if (!data) return null;
  return (
    <Dialog open={!!data} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="w-[500px] max-w-[95vw]">
        <DialogHeader className="text-left">
          <DialogTitle>BT avec dates séparées</DialogTitle>
          <DialogDescription>
            Ce bon de travail a des dates non-consécutives. Voulez-vous déplacer seulement un segment ou tout le bloc ?
          </DialogDescription>
        </DialogHeader>

        <div className="py-4 space-y-3">
          <p className="text-sm font-medium text-gray-700">Segments détectés :</p>
          {data.segments.map((segment, idx) => {
            const start = segment[0];
            const end = segment[segment.length - 1];
            const startDate = new Date(start + 'T12:00:00').toLocaleDateString('fr-CA', { day: 'numeric', month: 'short' });
            const endDate = new Date(end + 'T12:00:00').toLocaleDateString('fr-CA', { day: 'numeric', month: 'short' });

            return (
              <Button
                key={idx}
                variant="outline"
                className="w-full justify-start text-left h-auto py-3"
                onClick={() => onSegmentSelect(data.bon, segment)}
              >
                <div>
                  <div className="font-medium">Segment {idx + 1}</div>
                  <div className="text-xs text-gray-500">
                    {startDate} → {endDate} ({segment.length} jour{segment.length > 1 ? 's' : ''})
                  </div>
                </div>
              </Button>
            );
          })}

          <div className="border-t pt-3 mt-3">
            <Button
              variant="default"
              className="w-full bg-blue-600 hover:bg-blue-700"
              onClick={() => {
                const allDates = data.segments.flat().sort();
                onBlockSelect(data.bon, allDates);
              }}
            >
              Déplacer TOUT le bloc
            </Button>
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Annuler
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default DialogSegmentChoice;
